import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalCadastroContadorComponent } from '../shared/modal/modal-cadastro-contador/modal-cadastro-contador.component';
import { ModalConfirmaExContadorComponent } from '../shared/modal/modal-confirma-ex-contador/modal-confirma-ex-contador.component';
import { ContadorService } from '../services/contador.service';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from '../token.service';
import { ModalExibirContadorComponent } from '../shared/modal/modal-exibir-contador/modal-exibir-contador.component';
import { ModalEditarContadorComponent } from '../shared/modal/modal-editar-contador/modal-editar-contador.component';
import { ErrorHandlerService } from '../errorHandler.service';
import { environment } from 'src/environments/environment';

// import * as $ from 'jquery';
// import 'datatables.net';

@Component({
  selector: 'app-registro-contador',
  templateUrl: './registro-contador.component.html',
  styleUrls: ['./registro-contador.component.scss']
})

export class RegistroContadorComponent implements OnInit {

  // $: any;
  public contador: any = {};
  public cnpjSucessora: any = null;
  public cnpjSucessoraPesquisado: number;
  public isContador: boolean = false;
  public isLoading: boolean = false;
  public isDisabledButton: boolean = false;
  public isBotaoCadastrar: boolean = false;
  public isOrigemReceita: boolean;
  public modalOption: NgbModalOptions = {};
  loginAuth: string;

  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private ContadorService: ContadorService,
    private toastyService: ToastrService,
    private handlerError: ErrorHandlerService,
    private tokenService: TokenService
  ) { }

  ngOnInit() {

    this.route.queryParams.subscribe(
      (queryParams: any) => {
        if (queryParams['tkLogin']) {
          sessionStorage.setItem('loginAuth', queryParams['tkLogin']);
        }
      }
    );

    this.loginAuth = sessionStorage.getItem('loginAuth');

    this.validaToken(this.loginAuth);

    if (!$('.li-seta').hasClass('ativo')) { //FECHA O SIDE
      $('.li-seta').removeClass('ativo');
      $('.content-inner').animate({ paddingLeft: '6.8rem' });
      $('.navbar-minimal.open').css('width', '80px');
      $('.fa-angle-double-left').addClass('fa-angle-double-right');
      $('.fa-angle-double-left').removeClass('fa-angle-double-left');
      $('li a span').addClass('desc');
      $('li a').removeClass('text-right');
      $('li a').addClass('text-center');
      $('li a span').css('margin', '-20px 0 0 35px');
      $('.nomeExpandir').html(' Expandir Menu ');
    } else { //ABRE O SIDE
      $('.li-seta').addClass('ativo');
      $('.content-inner').animate({ paddingLeft: '18rem' });
      $('.navbar-minimal.open').css('width', '260px');
      $('.fa-angle-double-right').addClass('fa-angle-double-left');
      $('.fa-angle-double-right').removeClass('fa-angle-double-right');
      $('li a span').removeClass('desc');
      $('li a').removeClass('text-center');
      $('li a').addClass('text-right');
      $('li a span').css('margin', '10px');
      $('li a i').css('width', '20px');
      $('.nomeExpandir').html(' Recolher Menu ');
    }

    //this.carregaTable();
  }

  openModalCadastroContador() {
    const modal = this.modalService.open(ModalCadastroContadorComponent, { size: <any>'xl' , centered: true , backdrop: 'static', keyboard: false });
    modal.componentInstance.cnpjSucessora = this.cnpjSucessoraPesquisado;
    modal.componentInstance.reload.subscribe( () => {
      this.loadContador();
    })
  }

  openModalViewContador() {
    const viewProcuracao = this.modalService.open(ModalExibirContadorComponent, { size: <any>'xl' , centered: true , backdrop: 'static', keyboard: false  });
    viewProcuracao.componentInstance.contador = this.contador;
  }

  openModalAlteracaoContador() {
    const modal = this.modalService.open(ModalEditarContadorComponent, { size: <any>'xl' , centered: true , backdrop: 'static', keyboard: false  });
    modal.componentInstance.contador = this.contador;
    modal.componentInstance.reload.subscribe( () => {
      this.loadContador();
    })
  }

  openModalExluirContador() {
    const modal = this.modalService.open(ModalConfirmaExContadorComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    modal.componentInstance.idContador = this.contador['idContador'];
    modal.componentInstance.reload.subscribe( () => {
      this.loadContador();
    })
  }

  carregaTable() {
    const table = $('.tabelaListaContador').DataTable();
    table.destroy();
    setTimeout(function () {
      $('.tabelaListaContador').DataTable({
        language: {
          url: 'https://cdn.datatables.net/plug-ins/1.10.19/i18n/Portuguese-Brasil.json'
        },
        'lengthMenu': [5, 10, 20, 30]
      });
    }, 50);
  }

  loadContador(){ 
    this.tokenService.canActivate();
    this.isContador = false;
    this.isDisabledButton = true;
    // this.isLoading = true;
    this.contador = null;
    this.isBotaoCadastrar = false;
    this.cnpjSucessoraPesquisado = this.cnpjSucessora;
    
    this.ContadorService.getContador( this.cnpjSucessora )
    .then( data => {
      this.contador = data;
      this.isContador = true;
      // this.isLoading = false;
      this.isDisabledButton = false;
      this.isOrigemReceita = data.origemReceita;
      this.contador.contemContador == false ? this.isBotaoCadastrar = true : this.isBotaoCadastrar = false;
    }).catch( err => {
      this.handlerError.handle(err);
      // this.isLoading = false;
      this.isDisabledButton = false;
      //err.error.mensagem == 'Não existe contador vinculado ao CNPJ informado.' ? this.isBotaoCadastrar = true : this.isBotaoCadastrar = false;
    }) 
  }

  validaToken(token: any) {
    this.tokenService
      .validaToken(token)
      .then(data => {
        if (typeof data !== 'undefined' && typeof data.cpf !== 'undefined') {
          this.redirectToken(true);
        } else {
          if (environment.mockToken) {
            this.redirectToken(true);
          } else {
            this.redirectToken(false);
          }
        }
      })
      .catch(error => {
        if (environment.mockToken) {
          this.redirectToken(true);
        } else {
          this.redirectToken(false);
        }
      });
  }
  
  redirectToken(tkAtivo: boolean) {
    if (tkAtivo) {
      this.router.navigate(['/registro-contador']);
    } else {
      // PARA LOGAR SEM TOKEN
      if (environment.mockToken) {
        this.router.navigate(['/registro-contador']);
      } else {
        // PARA LOGAR COM TOKEN
        if (window.location.href.indexOf('/login') == -1) {
          window.location.href = environment.baseURL;
        }
      }
    }
  }

}